import {createSvgIcon} from "@mui/material";
import React from "react";

const KotlinIcon = createSvgIcon(
    <svg
        viewBox="0 0 24 24"
        fill="currentColor"
        height="1em"
        width="1em"
    >
        <path d="M24 24H0V0h24L12 12Z"/>
    </svg>,
    "Kotlin"
)

export default KotlinIcon;
